export default __webpack_public_path__ + "5da8289d1f4e4e0b0e3cf4c95dcccb06.png";